import { ValueFormatterParams } from "ag-grid-community";

import { formatNumber } from "fond/utils/number";

const numberValueFormatter = ({ value }: ValueFormatterParams): string => formatNumber(value);

export default numberValueFormatter;
